var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fullscreen-spinner"},[_c('div',{staticClass:"center-screen",staticStyle:{"text-align":"center"}},[_c('i',{staticClass:"fa fa-circle-notch fa-spin fa-3x fa-fw"}),_c('div',[_vm._v("Saving")])])])
}]

export { render, staticRenderFns }